import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../../core/auth.service';
import { Investor } from '../../../shared/models/investor';
import { InvestorDataService } from '../../../../core/investor-data.service';

@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.css']
})
export class ManageComponent implements OnInit {

  constructor(
    private ids: InvestorDataService,
    private auth: AuthService,
    private Activatedroute: ActivatedRoute,
  ) { }
  currentPosition: number;
  investor: Investor;
  new_risk_category: string;
  category = "basic";
  once = false;

  ngOnInit() {
    const iid = this.Activatedroute.snapshot.params['uid'];
    this.currentPosition = 0;
    this.ids
      .getInvestorByKey(iid)
      .get()
      .then((value) => {
        this.investor = new Investor(value.data());
        // console.log("hello", this.investor, this.RiskCharts.processData);
        this.new_risk_category = this.investor.risk_category;
        // console.log('hello', value);
        // this.RiskCharts.processData(this.investor);
        // console.log('hello', value);
      });
  }

  handleNext(){
    this.currentPosition = 1;
    console.log('next jay che')
  }
  handlePrev(){
    this.currentPosition = 0;
    console.log('pachu ave che')
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/reports/manage/manage.component.ts